﻿export function setupAccountTitles() {
    const jobtitleStartState = $("[data-job-details] [name='Input.JobTitle']").val();
    if (jobtitleStartState == "14") {
        $("[data-job-details] [data-other-job-title]").show();
    } else {
        $("[data-job-details] [data-other-job-title]").hide();
    }

    const sectorStartState = $("[data-job-details] [name='Input.IndustrySector']").val();
    if (sectorStartState == "8") {
        $("[data-job-details] [data-other-sector]").show();
    } else {
        $("[data-job-details] [data-other-sector]").hide();
    }

    $("[data-job-details] [name='Input.JobTitle']").change(function () {
        const jobtitle = $("[data-job-details] [name='Input.JobTitle']").val();
        if (jobtitle == "14") {
            $("[data-job-details] [data-other-job-title]").show();
        } else {
            $("[data-job-details] [data-other-job-title]").hide();
        }
    });

    $("[data-job-details] [name='Input.IndustrySector']").change(function () {
        const sector = $("[data-job-details] [name='Input.IndustrySector']").val();
        if (sector == "8") {
            $("[data-job-details] [data-other-sector]").show();
        } else {
            $("[data-job-details] [data-other-sector]").hide();
        }
    });
}